import { useState } from "react";

import {
  IoCloudUploadOutline,
  IoEllipsisHorizontal,
  IoSettingsOutline,
  IoDocumentOutline,
  IoBuildOutline,
  IoTrashOutline,
} from "react-icons/io5";

import Dropdown from "./../../../components/common/Dropdown";
import Modal from "../../../components/common/Modal";
import CorItemForm from "./CorItemForm";

import moment from "moment";
import CorDeadlineForm from "./CorDeadlineForm";
import CorDeadlineDelete from "./CorDeadlineDelete";

const columns = [
  { name: "Items" },
  { name: "Period" },
  { name: "Due" },
  { name: "Status" },
  { name: "" },
];

const CorTable = ({ deadlines, setDeadlines }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showDeadlineForm, setShowDeadlineForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [selectedCorItem, setSelectedCorItem] = useState(null);

  const handleSelectCorItem = (item) => {
    const result = item ?? null;
    setSelectedCorItem(result);
    setShowForm(!showForm);
  };

  const handleDeadline = (item) => {
    const result = item ?? null;
    setSelectedCorItem(result);
    setShowDeadlineForm(!showDeadlineForm);
  };

  const handleDeleteDeadline = (item) => {
    const result = item ?? null;
    setSelectedCorItem(result);
    setShowDeleteForm(!showDeleteForm);
  };

  const handleSuccess = (item) => {
    const index = deadlines.findIndex((i) => i.id === item.id);

    const items = [...deadlines];
    items[index] = item;
    setDeadlines(items);
    handleSelectCorItem();
  };

  const handleDeadlineSuccess = (item) => {
    const index = deadlines.findIndex((i) => i.id === item.id);

    const items = [...deadlines];
    const new_item = { ...items[index] };
    new_item["end_date"] = item.end_date;

    items[index] = new_item;
    setDeadlines(items);
    handleDeadline();
  };

  const handleDeleteSuccess = (item) => {
    const new_deadlines = deadlines.filter((i) => i.id !== item.id);
    setDeadlines(new_deadlines);
    handleDeleteDeadline();
  };

  const tableRow = (item, index) => {
    const status = (
      <div className="flex items-center">
        <p className="text-gray-500">{item.status_type}</p>
      </div>
    );

    const options = [
      [
        {
          name: "Upload File",
          icon: <IoCloudUploadOutline className="mr-3 text-blue-400" />,
          action: () => handleSelectCorItem(item),
          is_disabled: item.filing_date,
        },
        {
          name: "View Document",
          icon: <IoDocumentOutline className="mr-3 text-green-400" />,
          is_disabled: !item.s3_reference_name,
          action: () =>
            window.open(
              item.s3_reference_name,
              "_blank",
              "noopener, noreferrer"
            ),
        },
        {
          name: "Edit Info",
          icon: <IoSettingsOutline className="mr-3 text-gray-400" />,
          action: () => handleSelectCorItem(item),
          is_disabled: !item.filing_date,
        },
      ],
      [
        {
          name: "Edit Deadline",
          icon: <IoBuildOutline className="mr-3 text-gray-400" />,
          action: () => handleDeadline(item),
        },
        {
          name: <span className="text-red-500">Delete Deadline</span>,
          icon: <IoTrashOutline className="mr-3 text-red-500" />,
          action: () => handleDeleteDeadline(item),
        },
      ],
    ];

    return (
      <tr
        className="border-b text-gray-500 border-gray-200 text-sm"
        key={index}
      >
        <td className="py-3 px-6 text-left whitespace-nowrap">{item.item}</td>
        <td className="py-3 px-6 text-left whitespace-nowrap">{item.period}</td>
        <td className="py-3 px-6 text-lef whitespace-nowrap">
          {moment(item.end_date).format("DD-MMM-yyyy")}
        </td>
        <td className="py-3 px-6 text-lef whitespace-nowrap">{status}</td>
        <td>
          <Dropdown
            items={options}
            icon={<IoEllipsisHorizontal className="text-blue-400" />}
          />
        </td>
      </tr>
    );
  };

  return (
    <>
      <table className="min-w-max w-full table-auto">
        <thead>
          <tr className="bg-gray-100 text-gray-500 uppercase text-sm leading-normal">
            {columns.map((item, index) => (
              <th key={index} className="py-3 px-6 text-left">
                {item.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{deadlines.map((item, index) => tableRow(item, index))}</tbody>
      </table>
      <Modal
        title={selectedCorItem && selectedCorItem.period}
        onClose={() => handleSelectCorItem()}
        isOpen={showForm}
        borderTop
      >
        <CorItemForm corDeadline={selectedCorItem} onSuccess={handleSuccess} />
      </Modal>
      <Modal
        title="Edit Deadline"
        onClose={() => handleDeadline()}
        isLoading={isLoading}
        isOpen={showDeadlineForm}
        borderTop
      >
        <CorDeadlineForm
          deadline={selectedCorItem}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleDeadlineSuccess}
        />
      </Modal>
      <Modal
        isLoading={isLoading}
        isOpen={showDeleteForm}
        onClose={() => handleDeleteDeadline()}
      >
        <CorDeadlineDelete
          deadline={selectedCorItem}
          setLoading={setIsLoading}
          onClose={() => handleDeleteDeadline()}
          onSuccess={handleDeleteSuccess}
        />
      </Modal>
    </>
  );
};

export default CorTable;
